module.exports = __webpack_public_path__ + "static/media/ajweb.7c2bd860.jpg";